/**
 * 电子回单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>电子回单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="批次名称 :">
            <el-input
              size="small"
              v-model="formInline.batchName"
              placeholder="请输入批次名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="用户姓名 :">
            <el-input
              size="small"
              v-model="formInline.name"
              placeholder="请输入用户姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="服务费 :">
            <el-input
              size="small"
              style="width: 47%"
              v-model="formInline.minServiceFee"
              placeholder="请输入"
            ></el-input>
            ~
            <el-input
              size="small"
              style="width: 47%"
              v-model="formInline.maxServiceFee"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="批次ID :">
            <el-input
              size="small"
              v-model="formInline.batchNumber"
              placeholder="请输入批次ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="结算时间 : ">
            <el-date-picker
              size="small"
              v-model="formInline.pay_date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button
        :loading="isExporting"
        size="small"
        type="primary"
        @click="exportdata"
        >导出数据</el-button
      >
      <el-button size="small" @click="exportPath">导出记录</el-button>
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="payeeName"
        label="用户姓名"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.payeeName)">
            {{ scope.row.payeeName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="identityDocumentNumber"
        label="证件信息"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.identityDocumentNumber)">
            {{ scope.row.identityDocumentNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceFee" label="服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.serviceFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收款信息" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.payeeAccount)">
            {{ scope.row.payeeAccount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="settlementAt"
        label="结算时间"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.settlementAt ? scope.row.settlementAt : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="batchName" label="批次名称" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.batchName)">
            {{ scope.row.batchName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="batchNumber" label="批次ID" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.batchNumber)">
            {{ scope.row.batchNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="电子回单" fixed="right">
        <template slot-scope="scope">
          <div class="btnNoBorderBlue" @click="viewBatch(scope.row.detailId)">
            查看
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
  </div>
</template>

<script>
import {
  settlementsEreceipts,
  checkeceipts,
  exportreceipts,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      status_list: [
        {
          label: "上线",
          value: 10,
        },
        {
          label: "下线",
          value: 20,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      isExporting: false,
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
        token: localStorage.getItem("logintoken"),
        merchantName: "",
        batchName: "",
        userName: "",
        settlementStartDate: "",
        settlementEndDate: "",
        minServiceFee: "",
        maxServiceFee: "",
        updateStartDate: "",
        updateEndDate: "",
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        batchNumber: "",
        batchName: "",
        status: 7,
        merchantName: "",
        idNumber: "",
        taskName: "",
        name: "",
        minServiceFee: "",
        maxServiceFee: "",
        settlementInfo: "",
        mobile: "",
        pay_date: [],
        date: [],
      },

      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        batchNumber: "",
        batchName: "",
        status: 7,
        merchantName: "",
        idNumber: "",
        taskName: "",
        payeeName: "",
        minServiceFee: "",
        maxServiceFee: "",
        settlementInfo: "",
        mobile: "",
        pay_date: [],
        date: [],
      };
      this.getdata(this.formInline);
    },
    exportdata() {
      this.isExporting = true;
      const { pay_date = [], date = [], ...restParams } = this.formInline;
      const requestParams = {
        ...restParams,
        settlementStartDate: pay_date[0] || "",
        settlementEndDate: pay_date[1] || "",
        updateStartDate: date[0] || "",
        updateEndDate: date[1] || "",
      };
      exportreceipts(requestParams)
        .then((res) => {
          this.isExporting = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            const exportId =
              (res.data && (res.data.id || res.data.exportId)) || "";
            this.$message({
              type: "success",
              message: "正在导出，请在导出记录中查看进度",
            });
            this.$router.push({
              path: "/payCenter/electronicReceiptExportList",
              query: exportId ? { id: exportId } : {},
            });
          }
        })
        .catch(() => {
          this.isExporting = false;
          this.$message({
            type: "error",
            message: "导出失败，请稍后重试",
          });
        });
    },
    exportPath() {
      this.$router.push({ path: "/payCenter/electronicReceiptExportList" });
    },
    viewBatch(data) {
      checkeceipts(data).then((res) => {
        if (res.msg != "success") {
          this.$message({
            type: "error",
            message: res.msg,
          });
        } else {
          window.open(res.data.downloadUrl);
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      const { pay_date = [], date = [], ...restParams } = parameter;
      const requestParams = {
        ...restParams,
        transactionStartDate: pay_date[0] || "",
        transactionEndDate: pay_date[1] || "",
        createdStartDate: date[0] || "",
        createdEndDate: date[1] || "",
      };

      settlementsEreceipts(requestParams)
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("菜单加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.btnNoBorderBlue {
  color: #1985ff;
  cursor: pointer;
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/electronicReceipt.vue